import Vue from 'vue'
import Vuex from 'vuex'

// 告诉 vue “使用” vuex
Vue.use(Vuex)

const state = {
	count : 0
}

const mutations = {
	//微信公众号部分数据
	underdata(state, info) {
		state.underylingData = info;
	},
	bmdata(state, info){
		state.underydatasj = info;
	},
	alldata(state, info){
		state.underyall = info;
	},
	searchjd(state, info){
		state.underyjd = info;
	},
	useriddata(state, info){
		state.underyuserid = info;
	},
	openiddata(state, info){
		state.underyopenid = info;
	},
	
	//后台部分数据
	userInfor(state, info){
		state.underyUser = info;
	},
	//所有城市信息
	cityData(state, info){
		state.underyCity = info;
	},
	//报名列表修改资料数据
	userData(state, info){
		state.underyData = info;
	},
	//准考证需要的信息
	ticketData(state, info){
		state.underyticket = info;
	},
	//权限模块gid传值
	gidData(state, info){
		state.underygid = info;
	},
	//用户列表模块修改 审核传参用户信息
	userAction(state, info){
		state.underyAction = info;
	},
}

export default new Vuex.Store({
  state,
  mutations
})


//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 